import { Component } from '@angular/core';
import { UnifiedDirectory } from '@unified-api/angular-directory';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-hris-integration-provider-selection-dialog',
  imports: [UnifiedDirectory, TranslocoPipe, MatIcon],
  templateUrl: './hris-integration-provider-selection-dialog.component.html',
  styleUrl: './hris-integration-provider-selection-dialog.component.scss',
})
export class HrisIntegrationProviderSelectionDialogComponent {
  protected readonly workspaceId = environment.unified.workspaceId;
  protected readonly environmentName = environment.unified.environmentName;
  protected readonly dataRegion = environment.unified.dataRegion;
  protected readonly permissionScopes = environment.unified.permissionScopes;
}
